import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Skeleton } from '@mui/material';
import { motion } from 'framer-motion';
import { Movie } from '../types';
import { tmdbService } from '../services/tmdbService';

interface MovieCardProps extends Movie {}

export const MovieCard: React.FC<MovieCardProps> = ({
  title,
  poster_path,
  vote_average,
  release_date,
}) => {
  const [imageLoaded, setImageLoaded] = React.useState(false);

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <Card
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'rgba(255,255,255,0.05)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255,255,255,0.1)',
          cursor: 'pointer',
          overflow: 'hidden',
          position: 'relative',
          '&:hover': {
            borderColor: 'primary.main',
            '& .MuiCardMedia-root': {
              transform: 'scale(1.05)',
            },
          },
        }}
      >
        <Box sx={{ position: 'relative', width: '100%', paddingTop: '150%' }}>
          {!imageLoaded && (
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                bgcolor: 'rgba(255,255,255,0.1)',
              }}
            />
          )}
          <CardMedia
            component="img"
            image={tmdbService.getImageUrl(poster_path, 'w500')}
            alt={title}
            onLoad={() => setImageLoaded(true)}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 0.3s ease-in-out',
            }}
          />
        </Box>
        <CardContent sx={{ flexGrow: 1, p: 2 }}>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            sx={{
              color: 'white',
              fontWeight: 600,
              fontSize: '1.1rem',
              lineHeight: 1.4,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {title}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mt: 1,
            }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ color: 'rgba(255,255,255,0.7)' }}
            >
              {new Date(release_date).getFullYear()}
            </Typography>
            <Typography
              variant="body2"
              color="primary"
              sx={{ fontWeight: 600 }}
            >
              {vote_average.toFixed(1)} ⭐
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </motion.div>
  );
}; 